import React, { Component } from 'react';
import Helmet from 'react-helmet';
import SessionStore from '../../stores/SessionStore';
import UserManagementStore from '../../stores/UserManagementStore';
import AccountsStore from '../../stores/AccountsStore';
import ApiUtils from '../../utils/ApiUtils';
import envConfig from '../../../static/config';
import { getBrandId } from '../../utils/BrandUtils';
import {
  setCardManagementBackNavigation,
  getCardManagementBackNavigation,
} from '../../utils/CardManagementUtils';
import UrlUtils from '../../utils/UrlUtils';
import InternetBankingActions from '../../actions/InternetBankingActions';
import StringConstants from '../../constants/StringConstants';
import { getDebitCardUrl } from '../../utils/NavigateToWebApps';
import { LiveChatTile } from '../common/SideBarTiles/LiveChatTile';
import EgainStore from '../../stores/EgainStore';
import { getSMEChat } from '../../egainChat/eGainChatSME';
import EgainActionCreator from '../../actions/EgainActionCreator';
import { GenericModal } from 'web-ui-components/lib/layout/content';
import { getChatContent } from '../common/GenericChatComponent';
import FavouritesStore from '../../stores/AccountsStore/FavouritesStore';
import { clearSelectedAccountId } from '../../actions/FavouritesActions';

class CardManagementLanding extends Component {
  constructor() {
    super();
    this.initiateChat = this.initiateChat.bind(this);
    this.onStoreChange = this.onStoreChange.bind(this);
    this.onChatClick = this.onChatClick.bind(this);
    this.onModalClose = this.onModalClose.bind(this);
    this.state = {
      showModal: false,
      saml: '',
      egainChat: UserManagementStore.isCA() && getSMEChat(),
    };
  }

  componentDidMount() {
    const {
      mountId,
      clientId,
      isPrivateUser,
      selectedAccountId,
      accountList,
      isBusinessUser,
      additionalSidebarContent,
      isLargeCustomer,
    } = this.getParamData();
    window.cybgCardManagementApp(
      mountId,
      this.getConfig(),
      clientId,
      this.handleBackClick,
      isPrivateUser,
      selectedAccountId,
      { accounts: accountList },
      isBusinessUser,
      additionalSidebarContent,
      isLargeCustomer
    );
    isBusinessUser && EgainStore.addChangeListener(this.onStoreChange);
  }
  componentWillUnmount() {
    const { isBusinessUser, isLargeCustomer } = this.getParamData();
    setCardManagementBackNavigation(undefined);
    isBusinessUser && EgainStore.removeChangeListener(this.onStoreChange);
    isLargeCustomer && clearSelectedAccountId();
  }
  getConfig = () => {
    const {
      apiBaseUrlPAAS,
      isCardManagementFreezeEnabled,
      debitCardWebAppLink,
    } = envConfig;
    return {
      clientContext: ApiUtils.getApiClientContext(),
      accessToken: SessionStore.getAll().accessToken,
      bankId: SessionStore.getSessionBankID(),
      brandId: getBrandId(),
      ibApiUrl: `${apiBaseUrlPAAS}/ibapi/v2`,
      baseURI: UrlUtils.getPathName(),
      baseImagePath: `/images/cards`,
      features: {
        isFreezeCardEnabled: isCardManagementFreezeEnabled,
      },
      debitCardWebAppLink: getDebitCardUrl(debitCardWebAppLink, {}),
    };
  };
  getParamData = () => {
    const isBusinessUser = UserManagementStore.isCA();
    const isLargeCustomer = FavouritesStore.isLargeCustomer();
    let selectedAccountId = AccountsStore.getAccount();
    let accountList = AccountsStore.getAccounts();
    if (isLargeCustomer) {
      selectedAccountId = FavouritesStore.getAccount();
      accountList = FavouritesStore.getAccounts();
      if (selectedAccountId) {
        const filteredAccount = accountList.filter(
          (account) => account.id === selectedAccountId
        );
        if (filteredAccount.length === 1) {
          accountList = FavouritesStore.getAccounts();
        } else {
          accountList = [FavouritesStore.getAccountDetail(selectedAccountId)];
        }
      }
    }
    return {
      clientId: 'IB_WEB',
      mountId: 'card-management-app',
      isPrivateUser: UserManagementStore.isPrivateUser(),
      selectedAccountId: getCardManagementBackNavigation()
        ? selectedAccountId
        : undefined,
      accountList: accountList,
      isBusinessUser: isBusinessUser,
      isLargeCustomer: isLargeCustomer,
      additionalSidebarContent: isBusinessUser && (
        <LiveChatTile
          content={getChatContent(this.props.content)}
          initiateChat={this.initiateChat}
        />
      ),
    };
  };
  handleBackClick = () => {
    const backNavigationPath = getCardManagementBackNavigation();
    InternetBankingActions.navigateToWebTask(
      backNavigationPath || StringConstants.WEB_HOMEPAGE
    );
  };
  onChatClick() {
    try {
      window.Microsoft.Omnichannel.LiveChatWidget.SDK.startChat();
    } catch (error) {
      window.dtrum?.reportError(error);
    }
    this.onModalClose();
  }
  onStoreChange() {
    const token = EgainStore.getSamlToken();
    if (this.state.saml !== token) {
      this.setState({
        saml: token,
      });
    }
  }
  initiateChat() {
    EgainActionCreator.getSamlToken();
    this.setState({
      showModal: true,
    });
  }
  onModalClose() {
    this.setState({ showModal: false });
  }
  render() {
    const {
      eGainChatModelHeader,
      eGainChatModelButtonText,
      eGainChatModelText,
    } = this.props.content;
    const { showModal } = this.state;
    const { isBusinessUser } = this.getParamData();
    return (
      <div className="bow page">
        <Helmet title="Card management" />
        <div id="card-management-app" className="web-ui-components" />
        {isBusinessUser && showModal && (
          <GenericModal
            titleText={eGainChatModelHeader}
            onConfirm={this.onChatClick}
            isOpen={showModal}
            onClose={this.onModalClose}
            confirmButtonText={eGainChatModelButtonText}
            isCentred
          >
            <p>{eGainChatModelText}</p>
          </GenericModal>
        )}
      </div>
    );
  }
}
export default CardManagementLanding;
